import React from "react";
import BreadCrumb from "../src/components/Shared/BreadCrumb";
import Contact from "../src/components/Home/Contact";
import Form from "../src/components/Shared/Form";
import SectionHead from "../src/components/Shared/SectionHead";
import { Col, Container, Row } from "react-bootstrap";
import Image from "next/future/image";
import mailIcon from "../src/assets/images/svg/contact/3.svg";
import phoneIcon from "../src/assets/images/svg/contact/1.svg";
import markerIcon from "../src/assets/images/svg/contact/2.svg";

import Link from "next/dist/client/link";
import server from "../src/api/server";
import { useIntl } from "react-intl";
import { NextSeo } from "next-seo";

const ContactPage = ({
  socialsData,
  mapFrame,
  error,
  contactUsBack,
  breadBackground,
  metaDataSections,
}) => {
  error && console.log(JSON.parse(error));
  const { formatMessage, locale } = useIntl();
  const contactMeta = metaDataSections?.find(
    (item) => item?.slug === "contact"
  );
  const neededInfo = socialsData?.filter((link) =>
    ["phone", "email", "location address", "location address_en"].includes(
      link?.socialType?.name?.en
    )
  );
  return (
    <>
      <NextSeo
        title={
          contactMeta?.name[locale] || formatMessage({ id: contactMeta?.slug })
        }
        description={
          contactMeta?.description[locale] ||
          formatMessage({ id: "Walid Ben Abdulaziz Ben mouzan" })
        }
        additionalMetaTags={[
          {
            name: "keywords",
            content: "",
          },
          {
            name: "description",
            content: "",
          },
        ]}
      />
      <div className="contact-page">
        <BreadCrumb
          title={formatMessage({ id: "contactVia" })}
          pageTitle={formatMessage({ id: "contactVia" })}
          breadBackground={breadBackground}
        />
        <div className="contact-page-top">
          <Container>
            <SectionHead
              subtitle={formatMessage({ id: "speakToUsVia" })}
              title={formatMessage({ id: "contactVia" })}
            />
            <Row className="justify-content-center">
              <Col xl={3} lg={3} md={6} xs={12}>
                <div
                  className="contact-item"
                  data-aos="fade-up"
                  data-aos-duration="300"
                  data-aos-delay="100"
                >
                  <div>
                    <Image
                      src={mailIcon.src}
                      width={30}
                      height={30}
                      alt=""
                      loading="lazy"
                    />
                  </div>
                  <p>
                    <Link
                      href={`mailto:${
                        neededInfo?.filter(
                          (link) => link.socialType.name.en === "email"
                        )[0]?.link
                      }`}
                    >
                      <a araia-label="go to mail">
                        {
                          neededInfo?.filter(
                            (link) => link.socialType.name.en === "email"
                          )[0]?.link
                        }
                      </a>
                    </Link>
                  </p>
                </div>
              </Col>
              <Col xl={3} lg={3} md={6} xs={12}>
                <div
                  className="contact-item"
                  data-aos="fade-up"
                  data-aos-duration="300"
                  data-aos-delay="200"
                >
                  <div>
                    <Image
                      src={phoneIcon.src}
                      width={30}
                      height={30}
                      alt=""
                      loading="lazy"
                    />
                  </div>
                  <p>
                    <Link
                      href={`tel:${
                        neededInfo?.filter(
                          (link) => link.socialType.name.en === "phone"
                        )[0]?.link
                      }`}
                    >
                      <a aria-label="go to phone">
                        {
                          neededInfo?.filter(
                            (link) => link.socialType.name.en === "phone"
                          )[0]?.link
                        }
                      </a>
                    </Link>
                  </p>
                </div>
              </Col>
              <Col xl={3} lg={3} md={6} xs={12}>
                <div
                  className="contact-item"
                  data-aos="fade-up"
                  data-aos-duration="300"
                  data-aos-delay="300"
                >
                  <div>
                    <Image
                      src={markerIcon.src}
                      width={30}
                      height={30}
                      alt=""
                      loading="lazy"
                    />
                  </div>
                  <p>
                    {
                      neededInfo?.filter(
                        (link) =>
                          link.socialType.name.en ===
                          `location address${locale === "ar" ? "" : "_en"}`
                      )[0]?.link
                    }
                  </p>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <div
          className="contact-page-map"
          data-aos="fade-up"
          data-aos-duration="300"
          data-aos-delay="400"
          dangerouslySetInnerHTML={{
            __html: mapFrame,
          }}
        ></div>
        <Form
          formTitle={formatMessage({ id: "toAskService" })}
          formSubtitle={formatMessage({ id: "askService" })}
        />
      </div>
    </>
  );
};

export const getStaticProps = async (ctx) => {
  try {
    const socialsResponse = await server.get("/settings/socials");
    const mapFrameResponse = await server.get("/settings/siteInfo/mapframe");
    const metaDataResponse = await server.get("/pages/metaData");
    let breadBack, contactUsBack;
    try {
      const backgroundResponse = await server.get("/pages/backgrounds");
      breadBack = backgroundResponse?.data?.data?.page?.sections?.find(
        (sec) => sec?.slug === "breadcrumbs"
      )?.image;
      contactUsBack = backgroundResponse?.data?.data?.page?.sections?.find(
        (sec) => sec?.slug === "contactUs"
      )?.image;
    } catch (err) {
      console.log(err);
    }
    return {
      revalidate: 1,
      props: {
        socialsData: socialsResponse?.data?.data?.socials,
        mapFrame: mapFrameResponse?.data?.data?.name,
        metaDataSections: metaDataResponse?.data?.data?.page?.sections,
        breadBackground: breadBack
          ? `${process.env.NEXT_PUBLIC_MAIN_URL}/${breadBack}`
          : "",
        contactUsBack: contactUsBack
          ? `${process.env.NEXT_PUBLIC_MAIN_URL}/${contactUsBack}`
          : "",
      },
    };
  } catch (error) {
    return {
      revalidate: 1,
      props: {
        error: JSON.stringify(error),
      },
    };
  }
};

export default ContactPage;
